import { render, staticRenderFns } from "./SettingsSnippet.vue?vue&type=template&id=3e58cebe"
import script from "./SettingsSnippet.vue?vue&type=script&lang=js"
export * from "./SettingsSnippet.vue?vue&type=script&lang=js"
import style0 from "./SettingsSnippet.vue?vue&type=style&index=0&id=3e58cebe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports